import type { Locale } from "@planerius/contracts"

import { useAccessState } from "../access/use-access"
import { FALLBACK_LOCALE, text, type TextKey } from "./dictionary"

/**
 * Язык человека и строки на нём.
 *
 * ЯЗЫК БЕРЁТСЯ ИЗ ПРОФИЛЯ, А НЕ ИЗ ПАМЯТИ УСТРОЙСТВА. Он хранится в учётке, значит
 * действует на всех устройствах и во всех салонах этого человека: вошёл с телефона —
 * увидел свой язык, без повторного выбора. Память браузера дала бы обратное: язык,
 * выбранный на рабочем компьютере, на телефоне сбрасывался бы в русский, и человек
 * решил бы, что настройка не сохраняется.
 *
 * ДО ЗАГРУЗКИ ПРОФИЛЯ — РУССКИЙ. На экране входа профиля ещё нет, и угадывать язык
 * по заголовкам браузера мы не будем: администратор салона в России с английской
 * системой получил бы английский интерфейс, которого не просил.
 */
export function useLocale(): Locale {
  const state = useAccessState()
  return state.kind === "ready" ? state.context.user.locale : FALLBACK_LOCALE
}

/** Строка на языке человека: `t("nav.journal")`. */
export function useText(): (key: TextKey, values?: Readonly<Record<string, string | number>>) => string {
  const locale = useLocale()
  return (key, values) => text(locale, key, values)
}
